import axios from "axios";
import config from "../../constants/config";

export const getAllUsersData = async (token,page,limit,searchQuery) => {
    console.log('called getAllUsersData');
    const url1 = config.API_URL + "/admin/users"
    return await axios.get(url1, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      },
      params:{
        page,limit,searchQuery
      }
    });
  };

export const getSearchUsersData = async (token,) => {
    console.log('called getSearchUsersData');
    const url1 = config.API_URL + "/admin/users"
    return await axios.get(url1, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      },
    });
  };


export const getUserData = async (token,id) => {
    console.log('called getUserData Method');
    const users = config.API_URL + "/admin/users/"+id;
    return await axios.get(users, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      },
    });
  };

export const getUserWalletData = async (token,currencyType,userID,page,limit,period,startDate,endDate) => {
  console.log('called getUserWalletData Method');
  const users = config.API_URL + "/admin/user/wallet/transactions";
  return await axios.get(users, {
    headers: {
      Authorization: token, // Correct placement of Authorization header
      'Content-Type': 'application/json', // Ensure content type is set to JSON
    },
    params:{
      userID,currencyType, page,limit,period,startDate,endDate
    }
  });
};


export const getUserPromotionalOffersData = async (token,userID,page,limit,period,startDate,endDate) => {
  console.log('called getUserPromotionalOffersData Method');
  const users = config.API_URL + "/admin/user/promotionalOffers";
  return await axios.get(users, {
    headers: {
      Authorization: token, // Correct placement of Authorization header
      'Content-Type': 'application/json', // Ensure content type is set to JSON
    },
    params:{
      userID, page,limit,period,startDate,endDate
    }
  });
};

export const getUserKaratDailyPromotionalOffersData = async (token,userID,page,limit,period,startDate,endDate) => {
  console.log('called getUserKaratDailyPromotionalOffersData Method');
  const users = config.API_URL + "/admin/user/karatPromotionalOffers";
  return await axios.get(users, {
    headers: {
      Authorization: token, // Correct placement of Authorization header
      'Content-Type': 'application/json', // Ensure content type is set to JSON
    },
    params:{
      userID, page,limit,period,startDate,endDate
    }
  });
};


export const updateUser = async (token,data) => {
  console.log('called updateUser Method');
  const users = config.API_URL + "/admin/user/edit";
  return await axios.put(users,data, {
    headers: {
      Authorization: token, // Correct placement of Authorization header
      'Content-Type': 'application/json', // Ensure content type is set to JSON
    },

  });
};

export const suspendedUser = async (token,data) => {
  console.log('called suspendedUser Method');
  const users = config.API_URL + "/admin/users/suspend";
  return await axios.put(users,data, {
    headers: {
      Authorization: token, // Correct placement of Authorization header
      'Content-Type': 'application/json', // Ensure content type is set to JSON
    },

  });
};
